import cn from 'classnames';
import type { ReactNode } from 'react';
import { useScroll } from '@shared/hooks/use-scroll';
import { PageTitle } from '../page-title';
import * as st from './styles.module.scss';

interface Props {
  Left?: JSX.Element;
  LeftSecondLine?: JSX.Element | null;
  Center?: string;
  CenterJSX?: ReactNode;
  Right?: JSX.Element;
  containerClassName?: string;
  scrollHeaderClassName?: string;
  disableHideBehavior?: boolean;
}

export const PageHead: React.FC<Props> = ({
  Left,
  LeftSecondLine,
  Center,
  Right,
  CenterJSX,
  containerClassName,
  scrollHeaderClassName,
  disableHideBehavior = false,
}) => {
  const { transformNav } = useScroll();
  return (
    <>
      {Center ? <PageTitle title={Center} disableHideBehavior={disableHideBehavior} /> : null}
      <div
        className={cn(st.scrollHeader, scrollHeaderClassName)}
        style={
          disableHideBehavior
            ? { transform: 'translateY(44px)' }
            : {
                transform: `${transformNav}`,
                transition: 'transform 0.5s ease-in-out',
              }
        }
      >
        <div id="nav-bar" className={st.wrapper}>
          <div className={cn(st.wrapper__container, containerClassName)}>
            <div className={st.wrapper__left}>{Left}</div>
            <div className={st.wrapper__center}>{CenterJSX}</div>
            <div className={st.wrapper__right}>{Right}</div>
          </div>
        </div>
        {LeftSecondLine && (
          <div id="nav-bar-second-line" className={st.wrapper}>
            <div className={cn(st.wrapper__container, containerClassName)}>
              <div className={st.wrapper__left}>{LeftSecondLine}</div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
